import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import emitter from "@/lib/emitter";
import {
  OnStartPurchaseData,
  PurchaseDetails,
  PurchaseResponse,
  SubscriptionDetails,
  SubscriptionResponse,
} from "@/payments/types";
import { EVENTS } from "@/const";
import SystemIntegration from "./integrations";

export default {
  purchase(details: PurchaseDetails): Promise<PurchaseResponse> {
    return new Promise((resolve, reject) => {
      const onPurchased = (response?: PurchaseResponse) => {
        if (!response) {
          reject("Can't find response!");
          return;
        }
        emitter.off<PurchaseResponse>(EVENTS.PAYMENT_PURCHASED, onPurchased);
        resolve(response);
      };
      emitter.emit<OnStartPurchaseData>(EVENTS.PAYMENT_START_PURCHASE, {
        pricePackageId: details.pricePackageId,
        price: details.price,
        paymentSystemId: details.paymentSystemId,
        purchaseSubject: details.subject,
      });
      emitter.on<PurchaseResponse>(EVENTS.PAYMENT_PURCHASED, onPurchased);
    });
  },

  subscribe(details: SubscriptionDetails): Promise<SubscriptionResponse> {
    return new Promise((resolve, reject) => {
      const onSubscribed = (response?: SubscriptionResponse) => {
        if (!response) {
          reject("Can't find response!");
          return;
        }
        emitter.off<SubscriptionResponse>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
        resolve(response);
      };
      emitter.emit<OnStartPurchaseData>(EVENTS.PAYMENT_START_PURCHASE, {
        pricePackageId: details.pricePackageId,
        price: details.price,
        paymentSystemId: details.paymentSystemId,
        subscriptionSubject: details.subscriptionSubject,
      });
      emitter.on<SubscriptionResponse>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
    });
  },

  checkAllowStoreCard: (system: PaymentSystemPublic) => SystemIntegration(system).allowSaveCard,
};
